<template>
  <div>
    <dialog-list-mxm-errors :errors="mxmErrors" v-model="dialogMxmErrors" />
    <q-table
      flat
      bordered
      :data="invoicesPaymentsStep === null ? [] : invoicesPaymentsStep"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :no-data-label="$t('no_data')"
      selection="multiple"
      :selected.sync="itemSelect"
    >
      <template v-slot:header-selection>
        <span>Selecionar</span>
      </template>
      <template v-slot:top>
        <q-toolbar>
          <q-btn
            color="positive"
            :label="$t('approve_selected_invoices')"
            no-caps
            unelevated
            class="q-px-md"
            @click="onActionInvoices(itemSelect)"
            :disabled="itemSelect.length == 0"
          >
          </q-btn>
        </q-toolbar>
      </template>

      <template v-slot:body-cell-status_erp="props">
        <q-td :props="props">
          {{ mxmStatusMap[props.row.mxm_status] }}

          <q-btn
            v-if="props.row.mxm_status == 4 || props.row.mxm_status == 5"
            color="negative"
            icon="warning"
            unelevated
            @click="showInvoiceMxmErrors(props.row)"
            round
            outline
            size="sm"
          >
            <q-tooltip content-class="bg-negative">{{ $t('view_details') }}</q-tooltip>
          </q-btn>
        </q-td>
      </template>

      <template v-slot:body-cell-invoice="props">
        <q-td :props="props">
          <q-btn
            flat
            color="primary"
            @click="showInvoice(props.row.outbound_invoice_uuid)"
            icon="fas fa-file-invoice-dollar"
          />
        </q-td>
      </template>

      <template v-slot:body-cell-id_invoices_payments="props">
        <q-td :props="props">
          <div class="ellipsis" style="max-width: 100px" v-if="props.row.invoice_payments_ids.split('').length > 12">
            {{ props.row.invoice_payments_ids.split(',').join(', ') }}
            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
              {{ props.row.invoice_payments_ids.split(',').join(', ') }}
            </q-tooltip>
          </div>
          <div v-else>
            {{ props.row.invoice_payments_ids.split(',').join(', ') }}
          </div>
        </q-td>
      </template>

      <template v-slot:body-cell-date="props">
        <q-td :props="props">
          <q-chip dense v-if="props.row.payment_day" color="primary" class="text-white">
            {{ $moment(props.row.payment_day).format('DD-MM-YYYY') }}
          </q-chip>
        </q-td>
      </template>

      <template v-slot:body-cell-actions="props">
        <q-td :props="props">
          <q-btn color="negative" unelevated flat icon="mdi-cancel" @click="onActionInvoices(props.row)" disable>
            <!-- :disable="itemSelect != 0" -->
            <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px"> {{ $t('repprove') }} </q-tooltip>
          </q-btn>

          <!-- v-if="props.row.file_id" -->
          <q-btn
            :disable="!props.row.file_id"
            :color="props.row.file_id ? `primary` : `grey-4`"
            unelevated
            flat
            :icon="props.row.file_id ? `mdi-eye-outline` : `mdi-eye-off-outline`"
            @click="openNfPDF(props.row)"
          >
            <q-tooltip v-if="props.row.file_id" content-class="bg-secondary text-white" content-style="font-size: 12px">
              {{ $t('view_invoice') }}</q-tooltip
            >
          </q-btn>
          <!-- <img :src="temporaryImgUrl" /> -->
        </q-td>
      </template>

      <template v-slot:header-cell-detailing="props">
        <q-th :props="props">
            <div class="flex items-center">
                {{ $t('details_2') }}
                 <q-tooltip content-class="bg-primary">{{ $t('view_csv_details') }}
                </q-tooltip>
            </div>
        </q-th>
      </template>

      <template v-slot:body-cell-detailing="props">
        <q-td :props="props">
            <q-btn
            dense
            round
            flat
            color="primary"
            icon="archive"
            @click="downloadInvoiceDetails(props.row.invoice_payments_ids)"
            :loading="isDownloading"
            >
            <q-tooltip>{{ $t('view_details') }}</q-tooltip>
            </q-btn>
        </q-td>
    </template>

      <template v-slot:bottom>
        <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
          <div class="row items-center">
            <span class="q-mr-md">{{$t('rows_per_page')}}</span>
            <q-select
              v-model="pagination.rowsPerPage"
              :options="[10, 20, 50, 100]"
              dense
              @input="onRowsPerPageChange"
              style="max-width: 60px; padding-left: 8px; padding-right: 8px"
            />
            <span>Total: {{ reqPagination.total }}</span>
          </div>
          <q-space />
          <q-pagination
            unelevated
            v-model="currentPage"
            color="primary"
            :max="reqPagination.last_page"
            :max-pages="6"
            boundary-numbers
            direction-links
          />
        </q-toolbar>
      </template>
    </q-table>
    <q-dialog v-model="dialog" persistent>
      <q-card style="min-width: 400px">
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title>
            {{ itemSelect.length != 0 ? this.$t('payment_information_2') : this.$t('reason_failure') }}
          </q-toolbar-title>
          <q-btn flat round dense icon="mdi-close" @click="onCloseDialog" />
        </q-toolbar>
        <q-card-section class="row q-col-gutter-md" v-if="itemSelect.length != 0">
          <div class="col-12 q-gutter-y-sm">
            <q-option-group v-model="integration" type="radio" color="secondary" :options="options" />

            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.empresaEmitente"
              :options="modalList.empresas"
              option-value="CodigoEmpresa"
              option-label="NomeEmpresa"
              :label="$t('emitting_company')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.empresaRecebedora"
              :options="modalList.empresas"
              option-value="CodigoEmpresa"
              option-label="NomeEmpresa"
              :label="$t('receiving_company')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.codigoFilial"
              :options="modalList.filiais"
              option-value="CodigoFilial"
              :option-label="(filial) => `${filial.CodigoFilial} - ${filial.NomeFilial}`"
              :label="this.$t('branch')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.tipoCobranca"
              :options="modalList.tiposDeCobrança"
              option-value="code"
              option-label="description"
              :label="$t('type_charge')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.codigoGrupo"
              :options="modalList.grupoDePagamento"
              option-value="Codigo"
              :option-label="(grupoDePagamento) => `${grupoDePagamento.Codigo} - ${grupoDePagamento.Descricao}`"
              :label="$t('group_code')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.numCentroCusto"
              :options="modalList.centrosDeCusto"
              option-value="CodigodoCentrodeCustos"
              :option-label="
                (centrosDeCusto) => `${centrosDeCusto.CodigodoCentrodeCustos} - ${centrosDeCusto.Descricao}`
              "
              :label="$t('cost_center')"
              outlined
              dense
              emit-value
              map-options
            />
            <q-select
              :disable="integration === 'internal'"
              v-model="formModalSelects.tipoTitulo"
              :options="modalList.tiposDeTitulo"
              option-value="code"
              option-label="description"
              :label="$t('title_type')"
              outlined
              dense
              emit-value
              map-options
            />
          </div>
          <div class="col-12">
            <date-input
              :v-model="formModal.date"
              @update="(value) => (formModal.date = value)"
              outlined
              :label="$t('payment_date')"
            />
          </div>
        </q-card-section>
        <q-card-section class="row q-col-gutter-md" v-else>
          <div class="col-12">
            <q-select
              v-model="formModal.motive"
              :options="[$t('others'), $t('incomplete_bank_details')]"
              :label="$t('motive')"
              outlined
              @input="setDefaultResponses"
            />
          </div>
          <div class="col-12">
            <q-input v-model="formModal.subject" type="text" :label="$t('subject')" outlined />
          </div>
          <div class="col-12">
            <q-input v-model="formModal.message" type="textarea" :label="$t('message')" outlined />
          </div>
        </q-card-section>
        <q-separator spaced />
        <q-card-actions align="right">
          <q-btn outline color="negative" :label="$t('cancel')" unelevated no-caps class="q-px-md" @click="onCloseDialog" />
          <q-btn
            v-if="itemSelect.length != 0"
            unelevated
            no-caps
            class="q-px-md"
            :label="$t('confirm_schedule')"
            color="primary"
            @click="onAlterPayment"
            :disable="isDisabled"
          />
          <q-btn
            v-else
            unelevated
            no-caps
            class="q-px-md"
            :label="$t('send_motive')"
            color="primary"
            @click="onSubmitMotive"
            :disable="formModal.subject == '' || formModal.subject == null"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import FinancialMixin from '../../mixins/FinancialMixin';
import FinanceService from '../../services/FinanceService';
import DialogListMxmErrors from './DialogListMxmErrors.vue';
import DateInput from '../../widgets/inputsGlobal/DateInput.vue';

export default {
  name: 'ListApproveInvoices',
  components: { DateInput, DialogListMxmErrors },
  mixins: [FinancialMixin, FinanceService],

  data() {
    return {
      isDownloading: false,
      dialog: false,
      dialogMxmErrors: false,
      mxmErrors: [],
      itemSelect: [],
      itemReprove: null,
      formModal: {
        subject: null,
        message: null,
        motive: 'Outros',
        date: null
      },
      params: {
        payout: null,
        paymentDay: null
      },
      columns: [
        {
          name: 'affilate_id',
          required: true,
          label: this.$t('affiliate_id'),
          align: 'left',
          field: 'affiliate_id',
          sortable: true
        },
        {
          name: 'affilate',
          required: true,
          label: this.$t('affiliate'),
          align: 'left',
          field: (row) => (row.affiliate ? row.affiliate.name : 'N/A'),
          sortable: true
        },
        {
          name: 'document_type',
          required: true,
          label: this.$t('origin'),
          align: 'left',
          field: (row) =>
            row?.document_type === 'CPF' || row?.document_type === 'CNPJ'
              ? 'Nacional'
              : row?.document_type === 'INTER'
              ? 'Internacional'
              : '-',
          sortable: true
        },
        {
          name: 'total_commissions',
          required: true,
          label: this.$t('invoice_amount'),
          align: 'left',
          field: 'total_commissions',
          format: (total_commissions) => `R$ ${total_commissions}`,
          sortable: true
        },
        {
          name: 'detailing',
          required: true,
          label: this.$t('details_2'),
          align: 'center',
          sortable: false
        },
        {
          name: 'invoice',
          required: true,
          label: this.$t('bill'),
          align: 'left',
          field: 'invoice',
          sortable: true
        },
        {
          name: 'id_invoices_payments',
          required: true,
          label: this.$t('invoice_number'),
          align: 'left',
          field: 'invoice_payments_ids',
          sortable: true
        },
        {
          name: 'date',
          required: true,
          label: this.$t('payment_date'),
          align: 'left',
          field: 'payment_day',
          sortable: true
        },

        {
          name: 'id_states',
          required: true,
          label: 'Status',
          align: 'left',
          field: 'id_states',
          format: (state) => this.formatStates(state),
          sortable: true
        },
        {
          name: 'status_erp',
          required: true,
          label: 'Status ERP',
          field: 'mxm_status',
          align: 'left',
          sortable: false
        },
        {
          name: 'actions',
          required: true,
          label: this.$t('actions'),
          align: 'center'
        }
      ],
      mxmStatusMap: [
        this.$t('not_sent'),
        this.$t('sent_to_mxm_waiting_processing'),
        this.$t('low_invoice_paid'),
        this.$t('processed_waiting_payment'),
        this.$t('error_sending_to_mxm_no_creation_in_erp'),
        this.$t('processing_error')
      ],
      pagination: {
        sortBy: 'trademark',
        descending: true,
        rowsPerPage: 10
      },
      modalList: [],
      formModalSelects: {
        empresaEmitente: null,
        empresaRecebedora: null,
        codigoFilial: null,
        tipoCobranca: null,
        codigoGrupo: null,
        numCentroCusto: null,
        tipoTitulo: null
      },

      options: [
        { label: this.$t('approval_via_mxm'), value: 'mxm' },
        { label: this.$t('internal_approval'), value: 'internal' }
      ],

      integration: 'mxm'
    };
  },

  created() {
    this.ActionSetFilterInvoicesPaymentsStep('states=%5B12%5D');
    this.setup();
    this.pagination.rowsPerPage = parseInt(localStorage.getItem('rowsPerPage.ApproveInvoices')) || 10;
    // this.getInvoicesPaymentsAffiliate(`%26page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);

    this.getInvoiceApprovalList().then((response) => {
      this.modalList = response.data;
    });
  },

  methods: {
    async downloadInvoiceDetails(invoiceIds) {
        this.isDownloading = true;
        await this.generateCommissionsDetailsCsv(
        Array.isArray(invoiceIds) ? invoiceIds : invoiceIds.split(',')
        );
        this.isDownloading = false;
    },

    clearForm() {
      for (let i in this.formModalSelects) {
        this.formModalSelects[i] = null;
      }
    },

    async openNfPDF(row) {
      this.$emit('showNfPopUp', row);
    },

    setup() {
      this.getInvoicesPaymentsAffiliate();
      for (let i in this.formModal) this.formModal[i] = null;
      this.formModal.motive = 'Outros';
      this.itemReprove = null;
      this.itemSelect = [];
      this.formModalSelects = {
        empresaEmitente: null,
        empresaRecebedora: null,
        codigoFilial: null,
        tipoCobranca: null,
        codigoGrupo: null,
        numCentroCusto: null,
        tipoTitulo: null
      };
    },
    setDefaultResponses(reason) {
      if (reason === this.$t('incomplete_bank_details')) {
        this.formModal.subject = this.$t('incomplete_bank_details');
        this.formModal.message =
          'Caro Afiliado, \n' +
          '\n' +
          'Por favor, verificar seus dados bancários. \n' +
          'Precisamos que todos os campos na área de informações para pagamento estejam preenchidos corretamente. \n' +
          '\n' +
          'Se precisar de ajuda, mande um e-mail para contato@afil.io. \n' +
          'Obrigado.';
      } else {
        this.formModal.subject = null;
        this.formModal.message = null;
      }
    },

    onActionInvoices(data) {
      this.dialog = true;
      if (data.isArray) this.itemSelect = data;
      else this.itemReprove = data;
    },

    onCloseDialog() {
      this.dialog = false;
      this.itemSelect = [];
      this.itemReprove = null;
      this.formModal = {
        subject: null,
        message: null,
        motive: 'Outros',
        date: null
      };
      this.formModalSelects = {
        empresaEmitente: null,
        empresaRecebedora: null,
        codigoFilial: null,
        tipoCobranca: null,
        codigoGrupo: null,
        numCentroCusto: null,
        tipoTitulo: null
      };
    },

    async onSubmitMotive() {
      this.onLoading(true);

      try {
        this.dialog = false;

        let formUpdate = {};

        formUpdate.invoices_payments_id = this.itemReprove.invoices_payments_id;
        formUpdate.disapproved_reason = this.formModal.motive;
        formUpdate.disapproved_title = this.formModal.title;
        formUpdate.disapproved_message = this.formModal.message;
        formUpdate.payment_day = null;
        formUpdate.id_states = 2;
        formUpdate.payment_status = 0;

        let request = {
          app: 'finance',
          path: '/api/invoices_payments/',
          params: {
            data: {
              invoices: JSON.stringify([formUpdate])
            }
          }
        };

        const { status } = await this.$http.put('v2/redirect', request);

        if (status === 200) {
          this.successNotify(this.$t('invoice_updated_successfully'));

          this.setup();
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async onAlterPayment() {
      this.onLoading(true);

      try {
        this.dialog = false;

        let formUpdate = [];

        for (let i in this.itemSelect) {
          let invoicePayments = this.itemSelect[i].invoice_payments_ids.split(',');

          for (let j in invoicePayments) {
            let form = {};

            form.invoices_payments_id = invoicePayments[j];
            form.disapproved_reason = null;
            form.disapproved_title = null;
            form.disapproved_message = null;
            form.id_states = 4;
            form.payment_status = 2;
            form.payment_day = this.formModal.date;

            formUpdate.push(form);
          }
        }

        let request = {
          app: 'finance',
          path: '/api/invoices_payments/',
          params: {
            data: {
              invoices: JSON.stringify(formUpdate),
              invoiceExtraFields: this.formModalSelects.empresaEmitente != null ? this.formModalSelects : null
            }
          }
        };
        const { status } = await this.$http.put('v2/redirect', request);

        if (status === 200) {
          this.successNotify(this.$t('invoice_updated_successfully'));

          this.setup();
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    formatPaymentDate(date) {
      console.log('date', date);
      if (date === null) {
        return this.$t('not_defined_date');
      } else {
        return this.$moment(date).format('L');
      }
    },

    async onUpdateRequest() {
      try {
        let UpdateParams = this.invoicesPaymentsStep.data.map(function (item) {
          let formattedValues = {};

          formattedValues.invoices_payments_id = item.invoices_payments_id;
          formattedValues.disapproved_reason = item.disapproved_reason;
          formattedValues.disapproved_title = item.disapproved_title;
          formattedValues.disapproved_message = item.disapproved_message;
          formattedValues.payment_day = this.$moment(this.stringToDate(item.payment_day, 'dd/MM/yyyy', '/')).format(
            'YYYY-MM-DD'
          );
          formattedValues.id_states = item.id_states;
          formattedValues.payment_status = item.payment_status;

          return formattedValues;
        });

        let request = {
          app: 'finance',
          path: '/api/invoices_payments/',
          params: {
            data: {
              invoices: JSON.stringify(UpdateParams)
            }
          }
        };

        const { status } = await this.$http.put('v2/redirect', this.parseQs(request));
        if (status === 200) {
          this.successNotify(this.$t('channels_added_successfully'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async showInvoiceMxmErrors(row) {
      try {
        this.onLoading(true);
        if (row.mxm_status === 4) {
          const { data } = await this.searchForMxmInvoiceLocalError(row.affiliate_id.toString().padStart(15, '0'));
          const parsedResponse = JSON.parse(data[0].response);
          this.mxmErrors = parsedResponse.response.Messages.map((val) => {
            return { message: val.Message };
          });
        } else {
          const { data } = await this.searchMxmInvoiceProcessError(row.mxm_process);
          this.mxmErrors = data;
        }

        this.dialogMxmErrors = true;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    showInvoice(invoiceHash) {
      let route = this.$router.resolve({ path: `/invoice/${invoiceHash}` });
      window.open(route.href, '_blank');
    },

    formatStates(state) {
      state = state.toString();
      switch (state) {
        case '1':
          return this.$t('approved'); //Aguardando liberação

        case '2':
          return this.$t('liberated'); //Liberado para solicitação

        case '3':
          return this.$t('requested'); //Aguardando agendamento

        case '4':
          return this.$t('scheduled');

        case '5':
          return this.$t('paid');

        case '11':
          return this.$t('refused');

        case '12':
          return this.$t('pre_approved');

        default:
          return '-';
      }
    },
    onRowsPerPageChange(value) {
      this.pagination.rowsPerPage = value;
      localStorage.setItem('rowsPerPage.ApproveInvoices', value);
      this.currentPage = 1;
      this.getInvoicesPaymentsAffiliate(`%26page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);
    }
  },

  watch: {
    itemsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pagination.page = 1;
        this.getInvoicesPaymentsAffiliate(`%26page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);
      }
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal && oldVal) {
        this.getInvoicesPaymentsAffiliate(`%26page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);
      }
    },

    integration: {
      handler() {
        if (this.integration === 'internal') this.clearForm();
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    },

    isDisabled() {
      const isFormModalInvalid =
        !this.formModalSelects.empresaEmitente ||
        !this.formModalSelects.empresaRecebedora ||
        !this.formModalSelects.codigoFilial ||
        !this.formModalSelects.tipoCobranca ||
        !this.formModalSelects.codigoGrupo ||
        !this.formModalSelects.numCentroCusto ||
        !this.formModalSelects.tipoTitulo ||
        !this.formModal.date;

      if (this.integration === 'internal' && this.formModal.date != null && this.formModal.date !== '') {
        return false;
      } else if (this.integration === 'mxm') {
        return isFormModalInvalid;
      }
      return true;
    }
  }
};
</script>
